import React, { useState } from 'react';
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

interface Benefit {
  id: number;
  title: string;
  description: string;
  image: { url: string; alternativeText?: string }[];
}

interface KeyBenefitsProps {
  benefits: Benefit[];
}

const KeyBenefits: React.FC<KeyBenefitsProps> = ({ benefits }) => {
  const [imagesLoaded, setImagesLoaded] = useState<{ [key: string]: boolean }>(
    {}
  );

  const handleImageLoad = (id: string) => {
    setImagesLoaded(prev => ({
      ...prev,
      [id]: true
    }));
  };

  return (
    <>
      <div className="flex flex-col gap-8 px-4 md:px-[5%] xl:px-[15%] md:hidden lg:flex lg:flex-row lg:gap-12">
        {benefits.map(item => (
          <div key={item.id} className="flex-1">
            <div className="relative mb-6 h-[225px] w-full overflow-hidden">
              <div
                className={`bg-gray-200 w-full h-full ${
                  imagesLoaded[`grid${item.id}`] ? 'hidden' : 'animate-pulse'
                }`}
              ></div>
              <div
                className={`${
                  imagesLoaded[`grid${item.id}`] ? '' : 'invisible'
                } h-full w-full`}
              >
                <Image
                  alt={
                    item.image[0]?.alternativeText ||
                    `Ambassador Image ${item.id}`
                  }
                  src={item.image[0]?.url}
                  width={378}
                  height={225}
                  loading="lazy"
                  className="object-cover w-full h-full"
                  onLoad={() => handleImageLoad(`grid${item.id}`)}
                />
              </div>
            </div>
            <h2 className="lg:text-[24px] md:text-[14px] font-bold text-primary lg:mb-4 mb-1">
              {item.title}
            </h2>
            <p
              className="text-primary xl:text-[16px] md:text-[14px] text-[14px]"
              dangerouslySetInnerHTML={{
                __html: item.description.replace(/\n/g, '<br />')
              }}
            ></p>
          </div>
        ))}
      </div>

      <div className="hidden md:block lg:hidden px-4 md:px-[5%]">
        <Swiper slidesPerView={2.5} spaceBetween={20} className="my-8">
          {benefits.map(item => (
            <SwiperSlide key={item.id}>
              <div className="pr-4">
                <div className="relative mb-6 w-full h-[150px] overflow-hidden">
                  <div
                    className={`bg-gray-200 w-full h-full ${
                      imagesLoaded[`swiper${item.id}`]
                        ? 'hidden'
                        : 'animate-pulse'
                    }`}
                  ></div>
                  <div
                    className={`${
                      imagesLoaded[`swiper${item.id}`] ? '' : 'invisible'
                    } h-full w-full`}
                  >
                    <Image
                      alt={
                        item.image[0]?.alternativeText ||
                        `Ambassador Image ${item.id}`
                      }
                      src={item.image[0]?.url}
                      width={325}
                      height={217}
                      loading="lazy"
                      className="object-cover w-full h-full"
                      onLoad={() => handleImageLoad(`swiper${item.id}`)}
                    />
                  </div>
                </div>
                <h2 className="md:text-[14px] font-bold text-primary mb-1">
                  {item.title}
                </h2>
                <p className="text-primary text-[14px]">{item.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default KeyBenefits;
